export const AusFlag =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/Australian-flag.svg";
export const USAFlag =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/American-flag.svg";
export const IndianFlag =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/Indian-flag.svg";
export const linkedin =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/linkedin.svg";
export const facebook =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/fb.svg";
export const instagram =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/instagram.svg";
export const youtube =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/footer/youtube.svg";
